module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideways-page-one"
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), (_vm.step === 0) ? _c('div', {
    staticClass: "flex-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setStep(3), _vm.getPresentations(), _vm.clear()
      }
    }
  }, [_vm._v(" Create a new Schedule")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setStep(2), _vm.getSchedules()
      }
    }
  }, [_vm._v(" Edit existing Schedule")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "flex-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.presentationList), function(pres, index) {
    return [(_vm.flaggedPresentations.indexOf(index) !== -1) ? _c('el-button', {
      staticStyle: {
        "width": "25%"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.selectPres(index)
        }
      }
    }, [_vm._v(" " + _vm._s(pres.name) + " ")]) : _c('el-button', {
      staticStyle: {
        "width": "25%"
      },
      attrs: {
        "type": "default"
      },
      on: {
        "click": function($event) {
          _vm.selectPres(index)
        }
      }
    }, [_vm._v(" " + _vm._s(pres.name) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('div', {
    staticClass: "flex-center"
  }, [(!_vm.edit) ? _c('div', [_c('h1', [_vm._v(" Create new Schedule ")]), _vm._v(" "), _c('h3', [_vm._v(" Selected Presentation: " + _vm._s(_vm.selectedPresentation.name) + " ")])]) : _c('div', [_c('h1', [_vm._v(" Edit Schedule ")]), _vm._v(" "), _c('h3', [_vm._v(" Selected Presentation: " + _vm._s(_vm.selectedPresentation.name) + " ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.type = 1, _vm.clear()
      }
    }
  }, [_vm._v("\n\t\t\t\tOne time\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.type = 2, _vm.clear()
      }
    }
  }, [_vm._v("\n\t\t\t\tRecurring/Weekly\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.type = 3, _vm.clear()
      }
    }
  }, [_vm._v("\n\t\t\t\tTime Limited/Weekly\n\t\t\t")])]), _vm._v(" "), (_vm.type === 1) ? _c('div', [_c('div', [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.multipleDays),
      callback: function($$v) {
        _vm.multipleDays = $$v
      },
      expression: "multipleDays"
    }
  }, _vm._l((_vm.days), function(item, i) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": i
      }
    })
  }))], 1), _vm._v(" "), _c('div', [_c('el-time-picker', {
    attrs: {
      "placeholder": "Select Start Time"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": " - ",
      "placeholder": "Select range",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addToList({
          start_time: _vm.timeFormat(_vm.startTime),
          presentation_id: _vm.selectedPresentation.presentation_id,
          day_of_week: _vm.multipleDays,
          schedule_type: 'one-time',
          start_datetime_range: _vm.dateFormat(_vm.dateRange[0]),
          end_datetime_range: _vm.dateFormat(_vm.dateRange[1])
        })
      }
    }
  }, [_vm._v(" Add ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('div', [_c('div', [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.multipleDays),
      callback: function($$v) {
        _vm.multipleDays = $$v
      },
      expression: "multipleDays"
    }
  }, _vm._l((_vm.days), function(item, i) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": i
      }
    })
  }))], 1), _vm._v(" "), _c('div', [_c('el-time-picker', {
    attrs: {
      "placeholder": "Select Start Time"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addToList({
          presentation_id: _vm.selectedPresentation.presentation_id,
          schedule_type: 'recurring/weekly',
          day_of_week: _vm.multipleDays,
          start_time: _vm.timeFormat(_vm.startTime)
        })
      }
    }
  }, [_vm._v(" Add ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.type === 3) ? _c('div', [_c('div', [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.multipleDays),
      callback: function($$v) {
        _vm.multipleDays = $$v
      },
      expression: "multipleDays"
    }
  }, _vm._l((_vm.days), function(item, i) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": i
      }
    })
  }))], 1), _vm._v(" "), _c('div', [_c('el-time-picker', {
    attrs: {
      "placeholder": "Select Start Time"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": " - ",
      "placeholder": "Select range",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addToList({
          start_time: _vm.timeFormat(_vm.startTime),
          presentation_id: _vm.selectedPresentation.presentation_id,
          day_of_week: _vm.multipleDays,
          schedule_type: 'one-time',
          start_datetime_range: _vm.dateFormat(_vm.dateRange[0]),
          end_datetime_range: _vm.dateFormat(_vm.dateRange[1])
        })
      }
    }
  }, [_vm._v(" Add ")])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.schedule), function(entry, i) {
    return (entry.presentation_id === _vm.selectedPresentation.presentation_id) ? _c('div', [_c('el-button', {
      attrs: {
        "type": "default"
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.days[entry.day_of_week]) + ", " + _vm._s(entry.schedule_type) + " "), (entry.start_time) ? [_vm._v(" at " + _vm._s(entry.start_time) + " ")] : _vm._e(), _vm._v(" "), (entry.start_datetime_range) ? [_vm._v(" " + _vm._s(entry.start_datetime_range) + " to " + _vm._s(entry.end_datetime_range) + " ")] : _vm._e()], 2), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.schedule.splice(i, 1)
        }
      }
    }, [_vm._v(" Delete ")])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(" Save ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setStep(0)
      }
    }
  }, [_vm._v(" Cancel ")])], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "flex-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_vm._l((_vm.scheduleList), function(schedule, index) {
    return [_c('el-button', {
      staticStyle: {
        "width": "25%"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.setStep(3), _vm.getPresentations(), _vm.setActiveSchedule(schedule.schedule_id), _vm.edit = true
        }
      }
    }, [_vm._v(" " + _vm._s(schedule.schedule_id) + " ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteSchedule(schedule.schedule_id, index)
        }
      }
    }, [_vm._v(" Delete ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" Schedule Manager ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" Select a Presentation ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" Select a Schedule ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bf7cd3b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Signage/Content.vue
// module id = 416
// module chunks = 1